import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiHelperService } from 'projects/apna-lib/src/lib/services/api-helper.service';
import { ConfigService } from 'projects/apna-lib/src/lib/services/config.service';
import { LoanGtmService } from 'projects/apna-lib/src/lib/services/loan-gtm.service';
import { UserIdentityService } from 'projects/apna-lib/src/lib/services/user-identity.service';
import mixpanel from "mixpanel-browser/src/loader-module";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'fa-loan-final-step',
  templateUrl: './loan-final-step.component.html',
  styleUrls: ['./loan-final-step.component.scss']
})
export class LoanFinalStepComponent implements OnInit {
  @ViewChild('content') content;
  open: boolean = false;
  encryptedText: string;
  isPartnerLink: boolean = false;
  partnerLogo: string;
  userData: {};
  isIndianMobile: boolean = true;
  loanApplicationVendors: any;
  loading: boolean = false;
  feedback: boolean = false;
  vendorList: any;
  showBankLogos: boolean = false;
  emailMessages = {
    yes: "Good, I Have Completed My Application",
    no: "Need Help in completing application",
    maybe: "Maybe Later"
  }
  puid: string;

  constructor(
    public loanService: LoanGtmService,
    private route: Router,
    private userIdentity: UserIdentityService,
    private apiHelper: ApiHelperService,
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal
  ) { }

  identify(user_id, userData = {}) {
    mixpanel.identify(user_id, userData)
  }

  trackEvent(event, data = {}) {
    mixpanel.track(event, data)
  }

  ngOnInit(): void {
    if (typeof window !== 'undefined' && !window.location.host.includes('localhost') && !window.location.host.includes('dev') && !window.location.host.includes('uat')) {
      mixpanel.init('36f7bc976b3c6dc024e372be5c7d26f8'); //change the token as per environment
    }
    setTimeout(() => {
      this.open = true
    }, 1500);

    const puid = this.activatedRoute.snapshot.paramMap.get('puid');
    if (puid) {
      localStorage.setItem('puid', puid);
      this.isPartnerLink = true;
      if (!this.loanService?.partnerDetails) {
        this.getPartnerDetails(puid);
      }
      else {
        this.puid = puid;
        this.partnerLogo = this.loanService.partnerDetails?.company?.showCompanyLogo ? this.loanService?.partnerDetails?.company?.logo : undefined;
      }
    }
    this.checkUserLoggedIn();
    this.getVendorDetails(this.loanService?.loanDetails?.id)

    setTimeout(()=>{
      this.showBankLogos = true;
    },1400)
  }

  getVendorDetails(loanId: string) {
    this.apiHelper.getData("loan-application-vendor", { where: { loanApplicationId: loanId }, fields: { vendor: true } }).then((result: any) => {
      this.vendorList = result;
      console.log(this.vendorList)
    })
  }

  getPartnerDetails(partnerUid) {
    this.apiHelper.getDataById("users/partner", partnerUid).subscribe((response: any) => {
      let partnerDetails = { ...response };
      if (partnerDetails) {
        this.puid = partnerDetails?.uid;
        this.loanService.studentDetails.parentId = partnerDetails?.id;
        this.loanService.partnerDetails = { ...partnerDetails };
        this.loanService.studentDetails.puid = partnerDetails?.uid;
        this.partnerLogo = partnerDetails?.company?.showCompanyLogo ? partnerDetails?.company?.logo : undefined;
      }
      else {
        this.isPartnerLink = false;
      }
    })
  }

  checkUserLoggedIn() {
    if (!this.loanService.studentDetails?.mobile) {
      if (this.isPartnerLink) {
        this.route.navigate([this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate(['']);
      return;
    }
    else if (!this.userIdentity.isLoggedIn.getValue()) {
      if (this.isPartnerLink) {
        this.route.navigate(['personal-details/' + this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate(['/personal-details']);
      return;
    }
    else if (!this.loanService?.loanDetails) {
      if (this.isPartnerLink) {
        this.route.navigate(['loan-details/' + this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate(['/loan-details']);
      return;
    }
    else {
      this.apiHelper.getData("loan-application-vendor", { where: { loanApplicationId: this.loanService?.loanDetails?.id } })
        .then((data: any) => {
          if (!(data && data?.length > 0)) {
            if (this.isPartnerLink) {
              this.route.navigate(['loan-details/' + this.loanService?.partnerDetails?.uid]);
              return;
            }
            this.route.navigate(['/loan-details']);
            return;
          }
          this.loanApplicationVendors = [...data];
        })
    }
    this.isIndianMobile = this.loanService.isMobileIndian(this.loanService.studentDetails.mobile);

    this.createEncryptedDetails();
  }

  createEncryptedDetails() {
    this.encryptedText = btoa(this.loanService.studentDetails.mobile);
  }

  redirectToBank() {
    this.loading = true;
    let vendorIds: string[] = [];

    for (let single of this.loanApplicationVendors) {
      vendorIds.push(single?.vendorId);
    }

    this.apiHelper.getData("users", { where: { id: { inq: vendorIds } } }).then((data: any) => {
      if (data && data?.length > 0) {
        for (let single of data) {
          this.openInNewTab(single?.company?.applicationUrl)
        }
        this.feedback = true;
      }
      this.loading = false;
    })
  }

  openInNewTab(url: string) {
    if (url) {
      if (window) {
        window.open(url, "_blank");
      }
    }
  }

  sendEmail(bodyMessage: string) {
    let emailObject: any = {
      subject: "International Loan Application",
      receivers: [
        {
          name: "Product Team",
          email: "product@foreignadmits.com"
        },
        {
          name: "Nikhil Jain",
          email: "nikhil@foreignadmits.com"
        },
        {
          name: "Himanshi Kuwarbie",
          email: "himanshi.kuwarbie@foreignadmits.com"
        }
      ],
      body: `
        <p>Student name: ${this.loanService?.studentDetails?.firstName + " " + this.loanService?.studentDetails?.lastName}</p>
        <p>Student mobile: ${this.loanService?.studentDetails?.mobile}</p>
        <p>Student email: ${this.loanService?.studentDetails?.email}</p>
        <p>Application status: ${bodyMessage}</p>
      `
    }
    this.apiHelper.postData("loan-applications/send-email", emailObject).subscribe((data) => {
      if (this.isPartnerLink) {
        this.route.navigate(['/thank-you/' + this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate(['/thank-you'])
    })
  }

  back() {
    if (this.isPartnerLink) {
      this.route.navigate(['result/' + this.loanService?.partnerDetails?.uid]);
      return;
    }
    this.route.navigate(['result'])
  }

  clearDetails() {
    if (typeof window !== 'undefined' && !window.location.host.includes('localhost') && !window.location.host.includes('dev') && !window.location.host.includes('uat')) {
      this.userData = {
        source: "Loan Widget",
      }
      if (this.loanService.partnerDetails) {
        this.userData["PartnerName"] = this.loanService.partnerDetails?.company.name;
      }
      this.trackEvent("Upload Documents on Loan Widget  Clicked", this.userData); //change the token as per environment
    }
    this.loanService.setDefaultDetails();
    if (this.isPartnerLink) {
      this.route.navigate(['/' + this.loanService?.partnerDetails?.uid]);
      return;
    }
    this.route.navigate(['/'])
  }

  raiseARequest() {
    this.modalService.open(this.content, { centered: true });
    let loanRequest: any = {
      id: this.loanService?.studentDetails?.id,
      name: `${this.loanService.studentDetails?.firstName + " " + this.loanService.studentDetails?.lastName}`,
      email: this.loanService.studentDetails?.email,
      mobile: this.loanService.studentDetails?.mobile,
      loanType: this.loanService.loanDetails?.loanType
    };

    if (this.isPartnerLink) {
      loanRequest.partnerName = this.loanService?.partnerDetails?.name;
      loanRequest.showAgentCode = this.loanService?.partnerDetails?.company?.showAgentCode ? true : false
    }
    this.apiHelper.postData("send-loan-application-request", loanRequest).subscribe(() => {
      this.apiHelper.openSnackBar("Sent request Successfully!");
    })
  }

  logout() {
    if (this.isPartnerLink) {
      this.route.navigate(['/' + this.loanService?.partnerDetails?.uid]);
      return;
    }
    this.route.navigate(['/'])
  }

}
